import { href, Link } from 'react-router'
// Imported (not a `public/` path) so Vite fingerprints it into
// `/assets/wordmark-dark-<hash>.svg` and it caches across page loads, rather
// than inlining the SVG markup into every SSR'd HTML document (VIT-17790).
import wordmarkDarkUrl from '../images/wordmark-dark.svg'

// Per VIT-16754 the "Log in" / "Sign up" links from the source design are
// intentionally omitted — there is no auth on the stub site yet.
export function SiteHeader() {
  return (
    <header className="px-3 sm:px-4">
      <div className="mx-auto flex py-3 sm:py-6 max-w-7xl items-center justify-between">
        <div className="flex items-baseline">
          <Link
            aria-label="Vital Care Finder — home"
            className="flex flex-none items-baseline gap-2 no-underline"
            to={href('/')}
            viewTransition
          >
            <img
              src={wordmarkDarkUrl}
              alt="Vital Atlas"
              width={220}
              height={50}
              className="[view-transition-name:wordmark]"
            />
          </Link>
        </div>
      </div>
    </header>
  )
}
